import React, { FC } from 'react';
import { Modal } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SecondaryButton } from 'common/components';
import { ReactComponent as CloseIcon } from 'application/assets/close.svg';
import { ReactComponent as SuccessIcon } from 'application/assets/success-icon.svg';
import { SuccessModalProps } from './models';
import { StyledModal } from './styles';

/**
 * React component that renders a modal dialog with a success message.
 *
 * @param title - the title of the modal
 * @param opened - a boolean indicating whether the modal is open or closed
 * @param onClose - a function that is called when the user closes the modal
 */
const SuccessModal: FC<SuccessModalProps> = ({ title, opened, onClose }) => {
  const { t } = useTranslation();
  return (
    <Modal open={opened}>
      <StyledModal>
        <CloseIcon onClick={onClose} />
        <div>
          <SuccessIcon />
          <p>{title}</p>
          <SecondaryButton onClick={onClose}>{t('global.ok')}</SecondaryButton>
        </div>
      </StyledModal>
    </Modal>
  );
};

export default SuccessModal;
